import $ from 'jquery';
import BaseComponent from '../../../general/js/base-component';
import contentBlocker from '../../../general/js/content-blocker';
import eventBus from '../../../general/js/event-bus';
import {EVENT_DEVICE_TYPE_CHANGED, DEVICE_TYPE_DESKTOP} from "../../../general/js/app";
import Stickyfill from 'stickyfilljs';

export default class LotNavigationComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.isOpened = false;

        this.menu = this.refs.menu;
        this.menuTrigger = this.refs.menuTrigger;
        this.overlay = this.refs.overlay;

        this.onMenuTriggerClick = this.onMenuTriggerClick.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);

        this.init();

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged.bind(this));
    }

    onDeviceTypeChanged(oldType, newType) {
        //switch from tablet/mobile to desktop
        //we have to close menu
        if (newType == DEVICE_TYPE_DESKTOP) {
            this.closeMenu();
        }
    }

    static getRequiredRefs() {
        return ['menu', 'menuTrigger', 'overlay'];
    }

    init() {
        let links = [...this.element.querySelectorAll('a')];
        links.forEach((link) => {
            link.addEventListener('click', this.onLinkClick);
        });

        this.menuTrigger.addEventListener('click', this.onMenuTriggerClick);
        this.overlay.addEventListener('click', this.onOverlayClick);
        Stickyfill.add(this.element);
    }

    onOverlayClick(e) {
        this.closeMenu();
    }

    onMenuTriggerClick() {
        if (!this.isOpened) {
            this.openMenu()
        } else {
            this.closeMenu()
        }
    }

    openMenu() {
        this.isOpened = true;
        this.element.classList.add('is-showing');
        setTimeout(() => {
            if (this.isOpened) {
                this.element.classList.add('is-shown');
            }
        }, 0);
        contentBlocker.block('lot-nav');
    }

    closeMenu() {
        this.isOpened = false;
        this.element.classList.remove('is-shown');
        contentBlocker.unblock('lot-nav');
        setTimeout(() => {
            if(!this.isOpened){
                this.element.classList.remove('is-showing');
            }
        }, 500);
    }

    onLinkClick(e) {

        let link = e.target;
        let target = link.getAttribute('href');

        if (target.indexOf('#') === 0) {
            e.preventDefault();
            let targetElement = document.querySelector(target);

            if(targetElement) {
                this.closeMenu();
                $("html, body").stop().animate({scrollTop: $(targetElement).offset().top - $('.header').outerHeight() - $(this.element).outerHeight()}, 500);
            }
        }

    }
}



// WEBPACK FOOTER //
// ./app/components/lot-details/js/lot-navigation.component.js